import Player from 'src/core/player/entities/Player';
import { IApplicationData } from 'src/interfaces/ApplicationData';
import { IProgressData } from 'src/interfaces/Progress';
import { sendProgress } from 'src/utils/progressUtils';
import TrackingService from '../TrackingService';

class ProgressService extends TrackingService<Omit<IProgressData, 'time'>> {
  constructor(applicationData: IApplicationData, protected player: Player) {
    super();

    this.player = player;
    this.data = {
      applicationKey: applicationData.applicationKey,
      duration: applicationData.mediaDuration,
      media: applicationData.mediaCode,
      reference: applicationData.reference || applicationData.userCode || '',
    };
  }

  get lastTimeWatched() {
    const { currentTime = 0 } = this.player;

    if (currentTime > 5) {
      return currentTime - 5;
    }

    return currentTime;
  }

  track() {
    if (!this.data.reference) return;

    this.captureEvent({
      ...this.data,
      time: this.lastTimeWatched,
    });
  }

  captureEvent(event: IProgressData) {
    if (this.isEventDuplicated(event)) return;

    sendProgress(event);
  }
}

export default ProgressService;
